import { useEffect, useRef } from "react"
import { fetchPartnerDiscounts, selectCurrentPage, selectCurrentPartner, selectPartnerDiscountsFirstLoad } from "../model"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { PartnerDiscountsTable } from "./partner-discounts-table"
import { DiscountsFilters } from "./discounts-filters"

export const PartnerDiscountsPage = () => {
    const isFirstRender = useRef(true)
    const discountsFirstLoad = useAppSelector(selectPartnerDiscountsFirstLoad)
    const page = useAppSelector(selectCurrentPage)
    const partnerId = useAppSelector(selectCurrentPartner)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (!isFirstRender.current) {
            dispatch(fetchPartnerDiscounts())
        }
    }, [page, partnerId])

    useEffect(() => {
        if (discountsFirstLoad) {
            dispatch(fetchPartnerDiscounts())
        }
        isFirstRender.current = false
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="Торговые точки" />
            <div className="flexbox">
                <PageSubtitle title="Скидки" />
                <DiscountsFilters />
                <PartnerDiscountsTable />
            </div>
        </div>
    )
}